































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Moment } from 'moment';
import { Event, Location, Picture } from '../../events//store/models';
import { Actions as EventsActions} from '@/modules/events/store/actions';
import { eventsModuleName } from '@/modules/events/store';
import router from '@/router';
const eventsModule = namespace(eventsModuleName);


@Component
export default class EventEdit extends Vue {

  @Prop() private eventId!: number;

  private locations: Location[] = [];
  private pictures: Picture[] = [];

  private formVisible: boolean = true;
  private isBusy: boolean = true;
  private eventItem: Event = {
    name: '',
    eventDateTime: this.$moment().seconds(0).toDate(),
    locationName: '',
    locationMapUrl: '',
    description: '',
    pictureUrl: '',
    showImmediately: false,
    isCanceled: false,
    };
  private eventDate: string = '';
  private eventTime: string = '';

  @eventsModule.Action(EventsActions.FETCH_EVENT) private fetchEventItem!: (eventId: number) => Event;
  @eventsModule.Action(EventsActions.SAVE_EVENT) private saveEvent!: (event: Event) => void;

  public async mounted() {
    this.isBusy = true;
    this.initLocations();
    this.initPictures();
    if (this.isEditMode()) {
      this.eventItem = { ...await this.fetchEventItem(this.eventId)};
    }

    this.eventDate = this.$moment(this.eventItem.eventDateTime).format('YYYY-MM-DD');
    this.eventTime = this.$moment(this.eventItem.eventDateTime).format('HH:mm:ss');
    this.isBusy = false;
  }

  private initLocations() {
    this.locations = [
      {name: 'Trawowa', description: 'boisko ul. Trawowa', mapUrl: 'https://goo.gl/maps/wpEmd', isDraft: true },
      {name: 'Sukielicka', description: 'boisko ul. Sukielicka', mapUrl: 'https://goo.gl/maps/chNbvZxWqWmsTdgf9', isDraft: true },
      {name: 'Zakrzów', description: 'Stadion Zakrzów', mapUrl: 'https://goo.gl/maps/hYra48ytaybDLBLK7', isDraft: true },
      {name: 'Beyzyma', description: 'boisko ul. Beyzyma', mapUrl: 'https://goo.gl/maps/Z6sx2', isDraft: true },
      {name: 'Lotnicza', description: 'boisko ul. Lotnicza', mapUrl: 'ttps://goo.gl/maps/79ECDAn85c62', isDraft: true },
      {name: 'Cmentarz Żołnierzy Polskich', description: 'Cmentarz Żołnierzy Polskich', mapUrl: 'https://goo.gl/maps/HdByKYPH7Nw', isDraft: true },
      {name: 'Inna Bajka', description: 'Restauracja Inna Bajka ul. Odrzańska 18/19', mapUrl: 'https://goo.gl/maps/soR9cvkjNEn', isDraft: true },
      {name: 'Wałbrzyska', description: 'boisko sztuczne ul. Wałbrzyska', mapUrl: 'https://goo.gl/maps/zZ2X1RZmv9H2', isDraft: true },
    ];
  }

  private initPictures() {
    this.pictures = [
      {name: 'Trening', pictureUrl: 'https://res.cloudinary.com/wksmuchoborwroclaw/image/upload/v1564234205/muchoborV2/assets/events/trening.jpg' },
      {name: 'Trening na bieżni', pictureUrl: 'https://res.cloudinary.com/wksmuchoborwroclaw/image/upload/v1564234315/muchoborV2/assets/events/trening-na-bie%C5%BCni.jpg' },
      {name: 'Trening biegowy', pictureUrl: 'https://res.cloudinary.com/wksmuchoborwroclaw/image/upload/v1564234232/muchoborV2/assets/events/trening-biegowy.jpg' },
      {name: 'Gierka', pictureUrl: 'https://res.cloudinary.com/wksmuchoborwroclaw/image/upload/v1564234264/muchoborV2/assets/events/gierka.jpg' },
      {name: 'Gierka na hali', pictureUrl: 'https://res.cloudinary.com/wksmuchoborwroclaw/image/upload/v1564234288/muchoborV2/assets/events/gierka-na-hali.jpg' },
    ];
  }

  private isEditMode(): boolean {
    return this.eventId !== undefined;
  }

  private locationClicked(description: string, mapUrl: string) {
    this.eventItem.locationName = description;
    this.eventItem.locationMapUrl = mapUrl;
  }

  private pictureClicked(pictureUrl: string) {
    this.eventItem.pictureUrl = pictureUrl;
  }

  private async submitted(event: any) {
    this.isBusy = true;
    event.preventDefault();
    this.eventItem.eventDateTime = this.$moment.utc(this.eventDate + 'T' + this.eventTime).toDate();
    await this.saveEvent(this.eventItem);
    this.isBusy = false;
    router.push({ name: 'events' });
  }

  private canceled() {
    router.push({ name: 'events' });
  }
}
